import React, { useState } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";

// components
import DeleteModal from "../../../../components/confirm-dialog/delete-modal";
import MessageModal from "../../../../components/Modal/message-modal";
import { useDeletePlaylistMutation } from "../../../../store/Reducer/playlist";

export default function TableBodyCustom({ data, index, onEditRow }) {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [messageModal, setMessageModal] = useState(false);

  const [deletePlaylist, { isLoading: isDeleting }] = useDeletePlaylistMutation();

  const openModal = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);
  const openMessageModal = () => setMessageModal(true);
  const closeMessageModal = () => setMessageModal(false);

  const handleDelete = async () => {
    if (selectedId) {
      try {
        await deletePlaylist(selectedId).unwrap();
        console.log("Record Deleted");
        closeModal();
      } catch (error) {
        console.error("Failed to delete news:", error);
      }
    }
  };


  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3 font-medium text-gray-900">{data?.name || "Untitled playlist"}</td>
        <td className="px-4 py-3">
          {data?.themeColor ? <span className="inline-flex items-center gap-2"><span className="h-4 w-4 rounded border border-gray-300" style={{ backgroundColor: data.themeColor }} aria-hidden="true" /><span className="font-mono text-xs text-gray-600">{data.themeColor}</span></span> : <span className="text-gray-400">—</span>}
        </td>
        <td className="px-4 py-3">
          {data?.isActive === false ? <StatusPill tone="gray">Inactive</StatusPill> : <StatusPill tone="green">Active</StatusPill>}
        </td>
        <td className="px-4 py-3">
          <RowActions onEdit={() => onEditRow(data)} onDelete={() => openModal(data?._id)} editLabel="Edit playlist" deleteLabel="Delete playlist" />
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        title="Are You Sure?"
        desc="This action will remove the event."
        onConfirm={handleDelete}
        onCancel={closeModal}
        isLoading={isDeleting}
      />

      <MessageModal
        isOpen={messageModal}
        data={data?.details}
        title="Message"
        onConfirm={handleDelete}
        onCancel={closeMessageModal}
      />
    </>
  );
}
